import React, { FC } from "react";
import injectSheet from "react-jss";
import styleSheet from "./styles";

interface Props {
  visible?: boolean;
  classes?: any;
}

const TableSelectedItem: FC<Props> = props => {
  return (
    <div
      style={{ display: props.visible ? "block" : "none" }}
      className={props.classes.circle}
    ></div>
  );
};

export default injectSheet(styleSheet)(TableSelectedItem);
